import { z } from 'zod';
import { decode } from './zodDecoder';

const GrantTypeC = z.enum([
    'authorization_code',
    'client_credentials',
    'partner_integration',
    'implicit',
    'refresh_token',
    'password',
]);

const PartnerIntegrationPermissionTemplateC = z.object({ service: z.string(), permissions: z.array(z.string()) });
export type PartnerIntegrationPermissionTemplate = z.infer<typeof PartnerIntegrationPermissionTemplateC>;

const ClientStatusC = z.enum(['enabled', 'disabled']);

const ExternalClientC = z.object({
    client_id: z.string(),
    name: z.string(),
    status: ClientStatusC,
    scopes: z.array(z.string()),
    grant_types: z.array(GrantTypeC),
    email: z.string(),
    description: z.string(),
    detailed_description: z.string(),
    created_at: z.string(),
    modified_at: z.string(),
    callback_urls: z.array(z.string()),
    client_credentials_permissions: z.array(z.unknown()),
    partner_integration_permission_templates: z.array(PartnerIntegrationPermissionTemplateC),
});

export type ExternalClient = z.infer<typeof ExternalClientC>;

const ClientC = z.object({
    id: z.string(),
    name: z.string(),
    status: ClientStatusC,
    scopes: z.array(z.string()),
    grantTypes: z.array(GrantTypeC),
    email: z.string(),
    description: z.string(),
    detailedDescription: z.string(),
    createdAt: z.string(),
    modifiedAt: z.string(),
    callbackUrls: z.array(z.string()),
    clientCredentialsPermissions: z.array(z.unknown()),
    partnerIntegrationPermissionTemplates: z.array(PartnerIntegrationPermissionTemplateC),
});

export type Client = z.infer<typeof ClientC>;

const ClientRegistryApiResponseC = z.array(ExternalClientC);
type ClientRegistryApiResponse = z.infer<typeof ClientRegistryApiResponseC>;

const decodeExternalClient = (input: unknown): ClientRegistryApiResponse => decode(input, ClientRegistryApiResponseC);

export const convertExternalToInternalClient = (input: ExternalClient): Client => ({
    id: input.client_id,
    name: input.name,
    status: input.status,
    scopes: input.scopes,
    grantTypes: input.grant_types,
    email: input.email,
    description: input.description,
    detailedDescription: input.detailed_description,
    createdAt: input.created_at,
    modifiedAt: input.modified_at,
    callbackUrls: input.callback_urls,
    clientCredentialsPermissions: input.client_credentials_permissions,
    partnerIntegrationPermissionTemplates: input.partner_integration_permission_templates,
});

export const decodeClientRegistryResponse = (input: unknown): Client[] =>
    decodeExternalClient(input).map(convertExternalToInternalClient);
